import { SeverityLevel } from '@app/common/models/severity-level';

export class NotificationSummary {
    constructor(public message: string, public location: string, public severity: SeverityLevel, public collectionName?: string, public collectionIndex?: number) { }
}
